import { render, staticRenderFns } from "./StatByPeriod.vue?vue&type=template&id=87d7d9ce&"
import script from "./StatByPeriod.vue?vue&type=script&lang=ts&"
export * from "./StatByPeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports